import { EventName } from '..';
import { z } from 'zod';

export enum OfflineUploadSourceType {
  OfflineEventSet = 'offline_event_set',
  Dataset = 'dataset',
}

export const OfflineEventSetUploadFBObjectSchema = z.object({
  id: z.string(),
  event_stats: z.string(), // json string mapped to json
  duplicate_entries: z.number(),
  matched_entries: z.number(),
  valid_entries: z.number(),
  match_rate_approx: z.number(),
  upload_tag: z.string(),
  first_upload_time: z.number().optional().nullable(),
  last_upload_time: z.number().optional().nullable(),
  creation_time: z.number().optional().nullable(),
  event_time_max: z.number().optional().nullable(),
  event_time_min: z.number().optional().nullable(),
});

export type OfflineEventSetUploadFBObject = z.infer<
  typeof OfflineEventSetUploadFBObjectSchema
>;

export interface OfflineEventSetUploadResponse {
  data: OfflineEventSetUploadFBObject[];
}

export interface OfflineEventSetUpload
  extends Omit<OfflineEventSetUploadFBObject, 'event_stats'> {
  event_stats: {
    [key in EventName]?: number;
  };
}

export interface MMOfflineEventSetUpload extends OfflineEventSetUpload {
  flagged: boolean;
}

export const exampleOfflineEventSetUploadResponse: OfflineEventSetUploadFBObject = {
  id: '11111111111',
  event_stats: '{"Purchase":1,"AddToCart":4}',
  duplicate_entries: 1,
  matched_entries: 2,
  valid_entries: 5,
  match_rate_approx: -1,
  upload_tag: 'test',
  first_upload_time: 1557385200,
  last_upload_time: 1562742000,
  event_time_max: 1557385200,
  event_time_min: 1562742000,
  creation_time: 1562742000,
};

export const exampleOfflineEventSetUpload: OfflineEventSetUpload = {
  ...exampleOfflineEventSetUploadResponse,
  event_stats: {
    Purchase: 1,
    AddToCart: 4,
  },
};

export const exampleMMOfflineEventSetUpload: MMOfflineEventSetUpload = {
  ...exampleOfflineEventSetUpload,
  flagged: false,
};
